function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("linearGradient", {
  id: "kwlcbvbb1a",
  x1: "67.702%",
  x2: "40.821%",
  y1: "40.14%",
  y2: "81.471%"
}, React.createElement("stop", {
  offset: "18%",
  stopColor: "#0052CC"
}), React.createElement("stop", {
  offset: "100%",
  stopColor: "#2684FF"
})), React.createElement("linearGradient", {
  id: "8dce6yqvab",
  x1: "32.526%",
  x2: "59.356%",
  y1: "59.401%",
  y2: "18.149%"
}, React.createElement("stop", {
  offset: "18%",
  stopColor: "#0052CC"
}), React.createElement("stop", {
  offset: "100%",
  stopColor: "#2684FF"
})));

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", null, React.createElement("g", null, React.createElement("g", {
  transform: "translate(-491 -7644) translate(-246 7268) translate(737 376)"
}, React.createElement("circle", {
  cx: 20,
  cy: 20,
  r: 13,
  fill: "#BFC0C2",
  stroke: "#F9F9F9",
  strokeWidth: 14
}), React.createElement("g", {
  fillRule: "nonzero"
}, React.createElement("path", {
  fill: "#253858",
  d: "M34.523 2.83h2.492v12.708c0 3.354-1.477 5.693-4.923 5.693-1.015.03-2.03-.154-3.015-.462v-2.43c.83.307 1.692.492 2.585.461 2.123 0 2.861-1.262 2.861-3.077V2.831zM41.57 1.846c.86-.061 1.6.585 1.66 1.446v.216c0 .923-.738 1.661-1.66 1.661-.924 0-1.662-.738-1.662-1.661-.062-.862.584-1.6 1.446-1.662h.215zM40.37 7.2h2.4v13.908h-2.4V7.2zM46.37 7.2h2.338v2.462c.8-1.631 2.215-2.8 4.923-2.647v2.339c-3.077-.308-4.923.615-4.923 3.57v8.214h-2.339V7.2zM64.862 18.615c-.893 1.847-2.554 2.77-4.708 2.77-3.692 0-5.57-3.139-5.57-7.231 0-3.939 1.94-7.23 5.847-7.23 2.03 0 3.6.922 4.43 2.738V7.2h2.4v13.908h-2.4v-2.493zm-4.062.554c2.154 0 4.062-1.354 4.062-4.461v-1.139c0-3.077-1.754-4.461-3.785-4.461-2.708 0-4.092 1.784-4.092 5.015 0 3.354 1.323 5.046 3.815 5.046zM81.415 21.385c-3.538 0-5.169-.708-6.584-1.416v-2.554c1.692.893 4.307 1.539 6.738 1.539 2.77 0 3.785-1.077 3.785-2.708 0-1.63-1.016-2.461-4.492-3.323-4.124-1.015-5.97-2.43-5.97-5.415 0-2.862 2.185-4.954 6.431-4.954 2.646 0 4.339.646 5.6 1.323v2.492c-1.754-.954-3.692-1.446-5.692-1.384-2.4 0-3.816.83-3.816 2.492 0 1.508 1.17 2.246 4.4 3.077 3.877.984 6.031 2.215 6.031 5.508 0 3.169-1.908 5.323-6.43 5.323zM89.97 14.123c0-4.185 2.46-7.2 6.615-7.2 4.184 0 6.584 3.046 6.584 7.2s-2.43 7.262-6.584 7.262-6.616-3.077-6.616-7.262zm2.338 0c0 2.646 1.323 5.046 4.277 5.046 2.953 0 4.246-2.4 4.246-5.046 0-2.646-1.293-4.954-4.246-4.954-2.954 0-4.277 2.308-4.277 4.954zM109.262 7.2h3.6v2.215h-3.6v11.693h-2.339V9.415h-2.277V7.2h2.246V5.692c0-2.584 1.446-4.338 4.431-4.338.554 0 1.077.061 1.6.215v2.216c-.492-.093-.985-.154-1.508-.154-1.477 0-2.215.861-2.215 2.123l.062 1.446zM120.923 18.77c.492 0 1.015-.093 1.508-.185v2.307c-.523.154-1.077.216-1.6.216-2.985 0-4.431-1.754-4.431-4.339V9.415h-2.277V7.2h2.246V4.246h2.339V7.2h3.692v2.215h-3.692v7.293c.03 1.23.769 2.061 2.215 2.061zM123.108 7.2L125.754 7.2 129.754 19.015 133.815 7.2 136.092 7.2 140.154 19.015 144.154 7.2 146.8 7.2 141.692 21.108 138.615 21.108 136.215 14.369 134.954 10.092 133.692 14.369 131.262 21.108 128.185 21.108zM157.754 18.615c-.892 1.847-2.554 2.77-4.708 2.77-3.692 0-5.57-3.139-5.57-7.231 0-3.939 1.94-7.23 5.847-7.23 2.03 0 3.6.922 4.43 2.738V7.2h2.4v13.908h-2.4v-2.493zm-4.062.554c2.154 0 4.062-1.354 4.062-4.461v-1.139c0-3.077-1.754-4.461-3.785-4.461-2.677.03-4.092 1.784-4.092 5.015 0 3.354 1.354 5.046 3.815 5.046zM163.785 7.2h2.338v2.462c.8-1.631 2.215-2.8 4.923-2.647v2.339c-3.077-.308-4.923.615-4.923 3.57v8.214h-2.338V7.2zM179.477 21.385c-5.2 0-7.477-3.016-7.477-7.262 0-4.215 2.338-7.2 6.585-7.2 4.277 0 6 2.985 6 7.2V15.2H174.43c.338 2.37 1.877 3.908 5.138 3.908 1.446 0 2.862-.246 4.246-.739v2.216c-1.169.584-2.923.8-4.338.8zm-5.108-8.216h7.785c-.154-2.584-1.323-4.061-3.692-4.061-2.554-.031-3.847 1.63-4.093 4.061z",
  transform: "translate(47.5 8.5)"
}), React.createElement("path", {
  fill: "#2684FF",
  d: "M22.862 11.292L12.554.985 11.569 0 3.815 7.754.277 11.292c-.37.37-.37.985 0 1.354l7.077 7.077 4.215 4.215 7.754-7.753.123-.123 3.416-3.416c.369-.37.369-.984 0-1.354zm-11.324 4.216L8 11.969l3.538-3.538 3.539 3.538-3.539 3.539z",
  transform: "translate(47.5 8.5)"
}), React.createElement("path", {
  fill: "url(#kwlcbvbb1a)",
  d: "M11.538 8.43C9.231 6.124 9.2 2.37 11.508.03L3.754 7.786 7.969 12l3.57-3.57z",
  transform: "translate(47.5 8.5)"
}), React.createElement("path", {
  fill: "url(#8dce6yqvab)",
  d: "M15.077 11.938l-3.539 3.539c2.339 2.338 2.339 6.092 0 8.43l7.785-7.784-4.246-4.185z",
  transform: "translate(47.5 8.5)"
}))))));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: 233,
    height: 40,
    viewBox: "0 0 233 40"
  }, props), _ref, _ref2);
};

export default __webpack_public_path__ + "static/media/integration-jira.53af8cb0.svg";
export { SvgComponent as ReactComponent };